import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getLocales } from './actionCreators';
import { LOCALES_SLICE_NAME, LocalesState, initialState } from './models';

export const localesSlice = createSlice({
  name: LOCALES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocales.fulfilled, (state: LocalesState, action) => {
        state.isLoading = false;
        state.availableLocales = action.payload;
      })
      .addMatcher(isPending(getLocales), (state: LocalesState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getLocales), (state: LocalesState, action) => {
        const { error } = action;

        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default localesSlice.reducer;
